<div class="test">
  Test component styles
</div>

<se-button
  se-data-emphasis="high"
  (click)="buttonClick()"
  se-data-value="Action">
</se-button>
